<template>
  <a-spin tip="Cargando..." :spinning="loading">
    <div class="contGral">
      <div class="header">
        <img :src="company.logo" width="170" style="margin-bottom: 30px" alt="Logo" >
      </div>
      <div id="messageDesuscripcion" class="form-messages" v-if="sent">
        <div class="icono icono-tic"></div>
        <div class="message">La desuscripción se ha realizado correctamente.</div>
      </div>
      <div id="formDesuscripcion" class="form" v-if="!sent">
        <p class="desuscripcion">Por favor contanos por qué ya no deseas seguir recibiendo nuestro newsletter:</p>
        <div class="form-group">
          <div class="areaMotivo">
            <a-textarea v-model="message" placeholder="contanos por qué ya no deseas seguir recibiendo nuestro newsletter"></a-textarea>
          </div>
        </div>
        <a-button @click="unsuscribe">Desuscribirme</a-button>
      </div>
    </div>
  </a-spin>

</template>

<script>

import utils from '../service/service.js'

export default {
  name: 'Unsuscripbe',
  props: [],
  components: {
  },
  mixins:[utils],
  data(){
    return {
      message:'',
      sent: false,
      loading: false,
      company: {},
    }
  },
  methods: {
    async unsuscribe() {
      this.loading = true;
      const { code } = await this.sendRequest({
        method:'POST',
        url:'/unsuscribe',
        data: {
          secret: this.$route.params.secret,
          email: this.$route.params.email,
          categoryId: this.$route.params.categoryId,
          mailingId: this.$route.params.mailingId,
          reason: this.message
        }
      });
      this.loading = false;
      if(code === 200) {
        this.sent = true;
      }
    },
    async getCompanyInformation() {
      const {data} = await this.sendRequest({
        method: 'GET',
        url: `categories/${this.$route.params.categoryId}/company`
      });
      this.company = data;

    }
  },
  computed: {
  },

  mounted: function(){
    this.getCompanyInformation()
  }
}
</script>

<style>
body {
  font-family: Arial, Helvetica, sans-serif;
  color: #666;
}
.contGral {
  width: 100%;
  max-width: 960px;
  margin: 0 auto;
  padding: 50px 15px;
  box-sizing: border-box;
}
.header h1 {
  text-align: center;
  font-size: 28px;
}
.header img {
  margin: 0 auto;
  display: block;
}
.form, .form-messages {
  max-width: 450px;
  display: table;
  margin: 0 auto;
}
.form p.desuscripcion {
  line-height: 1.4;
  margin-bottom: 35px;
}
.form-group {
  margin-top: 17px;
}
.form-group:first-of-type { margin-top: 0; }
.form-group input[type="radio"] {
  vertical-align: middle;
  height: 16px;
  width: 16px;
}
.form-group label {
  vertical-align: sub;
  cursor: pointer;
}
.areaOtros { margin-bottom: 10px; }
.areaMotivo { margin-bottom: 20px; }
.areaMotivo textarea {
  padding: 10px;
  width: calc(100% - 27px);
  box-sizing: border-box;
  font-family: Arial, Helvetica, sans-serif;
  color: #666;
  font-size: 16px;
  margin-left: 27px;
  height: 130px;
  line-height: 1.4;
  resize: vertical;
}
textarea[disabled] {
  background-color: #EFEFEF;
  border-color: #d7d7d7;
}
.btn {
  text-decoration: none;
  padding: 6px 15px;
  border-radius: 3px;
}
.btn-naranja {
  background: #FC830B;
  color: #FFF;
}
.btn span { vertical-align: middle; }
.btn i {
  font-size: 20px;
  vertical-align: middle;
  margin-right: -10px;
}
.btn-naranja:hover { background: #DF6C19; }
.form a { float: right; }
.form-messages .message {
  display: inline-block;
  vertical-align: middle;
}
.form-messages .icono {
  display: inline-block;
  vertical-align: middle;
  margin-right: 13px;
  width: 30px;
  height: 25px;
  background-size: 30px;
}
.icono-tic {
  background: url('http://cdn1.infocasas.com.uy/web/tic-unsus.png') no-repeat;
}
.icono-error {
  background: url('http://cdn1.infocasas.com.uy/web/cruz-unsus.png') no-repeat;
}
</style>